import React, { useState } from "react";
import { ErrorMessage, Formik } from "formik";
import * as yup from "yup";
import clsx from "clsx";
import toast, { Toaster } from "react-hot-toast";
import { CreateMarketingMaterial } from "../../../models/_marketingMaterial";
import Breadcrumb from "../../Common/Breadcrumb";

const validationSchema = yup.object({
  name: yup.string().required("Name is required"),
  priority: yup.string().required("Priority is required"),
});

function CreateMarketingMaterials() {
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <div id="kt_app_toolbar" className="app-toolbar py-2 pt-4">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-xxl d-block d-lg-flex d-md-flex d-xl-flex flex-stack px-3"
          style={{ maxWidth: "100%" }}
        >
          <div className="page-title d-flex flex-column justify-content-center flex-wrap">
            <h1 className="page-heading d-flex text-dark fw-bold fs-1 flex-column justify-content-center my-0">
              Create Marketing Material
            </h1>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3 mt-3 mt-lg-0 mt-md-0 mt-3 mt-lg-0 mt-md-0">
            <Breadcrumb
              links={[
              { label: "Home", href: "/dashboard", isActive: false },
              { label: "Create Marketing Material", href: "", isActive: true },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="card mx-xl-4 mt-9">
        <Formik
          initialValues={{
            name: "",
            priority: "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, { resetForm, setSubmitting }) => {
            setLoading(true);
            const $inputData: any = {
              name: values.name,
              priority: parseInt(values.priority),
            };
            const result = await CreateMarketingMaterial($inputData);
            if (result?.data?.data?.createMarketingMaterial) {
              toast.success("Marketing material created successfully");
              setLoading(false);
              setSubmitting(false);
              resetForm();
            } else {
              setSubmitting(false);
              setLoading(false);
              const messages = result?.data?.errors.map((e: any) => e.message);
              toast.error(messages.join(","));
            }
          }}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <div className="card-body w-100 p-lg-7 p-md-7 p-5">
              <form onSubmit={handleSubmit} autoComplete="off">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                    <label className="form-label fs-4 required fw-bold">
                      Name
                    </label>
                    <input
                      className={clsx("form-control", {
                        "is-invalid": Boolean(errors.name) && touched.name,
                      })}
                      name="name"
                      id="name"
                      value={values.name}
                      onChange={handleChange}
                    />
                    <div className="text-danger text-align-top-center mt-2">
                      <ErrorMessage name="name" />
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2 w-xl-25 pe-xl-5 ps-xl-5 mb-3 mb-lg-4">
                    <label className="form-label fw-bold required fs-4">
                      Priority
                    </label>
                    <input
                      type="number"
                      className={clsx("form-control", {
                        "is-invalid":
                          Boolean(errors.priority) && touched.priority,
                      })}
                      name="priority"
                      id="priority"
                      value={values.priority}
                      onChange={handleChange}
                    />
                    <div className="text-danger text-align-top-center mt-2">
                      <ErrorMessage name="priority" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-6 col-12 px-xl-5 p-2 mt-2">
                    <button
                      type="submit"
                      className="btn btn-primary me-4 fs-4 w-100 px-1 p-0 py-3"
                    >
                      {loading && (
                        <span
                          className="indicator-progress"
                          style={{ display: "block" }}
                        >
                          Please Wait..
                          <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                        </span>
                      )}
                      {!loading && (
                        <span className="indicator-label">ADD MARKETING MATERIAL</span>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </Formik>
        <Toaster
          position="bottom-left"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            className: "",
            duration: 3000,
          }}
        />
      </div>
    </div>
  );
}

export default CreateMarketingMaterials;
